import React, { useState, useEffect, useRef } from 'react';
import { Draggable } from '@hello-pangea/dnd';
import { StyledChecklistItemContainer } from '../styles/ChecklistItem.styles'; // Changed import
import ChecklistItemContent from './checklist/ChecklistItemContent';

const ChecklistItem = ({
    item,
    index,
    onToggle,
    onDelete,
    onUpdate,
    onConvert,
    isExpanded, // New prop
    handleCreateSubtaskFromChecklistItem // Receive new handler
}) => {
    const textareaRef = useRef(null);
    const [editedText, setEditedText] = useState(item.text);

    const adjustHeight = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = '24px'; // Reset height before calculating scrollHeight
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    };

    useEffect(() => {
        // Adjust height if the item's text changes OR if it becomes expanded
        // Only adjust if isExpanded is true or undefined (for components not in a collapsible list)
        if (isExpanded !== false) { // Check for explicitly false, allow undefined for backward compatibility
            adjustHeight();
        }
    }, [item.text, isExpanded]);

    const handleTextareaChange = (e) => {
        setEditedText(e.target.value);
        adjustHeight();
    };

    const handleBlur = () => {
        if (editedText !== item.text) {
            onUpdate(editedText);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleBlur();
            e.target.blur();
        }
    };

    return (
        <Draggable draggableId={item.id} index={index}>
            {(provided, snapshot) => (
                <StyledChecklistItemContainer // Changed from ItemContainer
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    isDragging={snapshot.isDragging}
                >
                    <ChecklistItemContent
                        textareaRef={textareaRef}
                        item={{...item, text: editedText}}
                        onToggle={onToggle}
                        onUpdate={handleTextareaChange}
                        onDelete={onDelete}
                        onBlur={handleBlur}
                        onKeyDown={handleKeyDown}
                        dragHandleProps={provided.dragHandleProps}
                        onConvert={onConvert}
                        handleCreateSubtaskFromChecklistItem={handleCreateSubtaskFromChecklistItem} // Pass down
                    />
                </StyledChecklistItemContainer>
            )}
        </Draggable>
    );
};

export default ChecklistItem;
